import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 12 12",
	style: { enableBackground: "new 0 0 12 12" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.plus-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus-icon-st0",
			d: "M1,6h10"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus-icon-st0",
			d: "M6,1v10"
		})
	]
});
export default SvgPlusIcon;
